import { HelpCenterComponent } from './help-center/help-center.component';
import { HelpCentersComponent } from './help-centers.component';
import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import {HelpCenterRoutingModule} from './help-center-routing.module';
import { HelpCenterSecondlevelComponent } from './help-center-secondlevel/help-center-secondlevel.component';
import { HelpCenterThirdlevelComponent } from './help-center-thirdlevel/help-center-thirdlevel.component';
import { HelpCenterPreviewComponent } from './help-center-preview/help-center-preview.component';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { HelpCenterService } from '../shared/Services/HelpCenterService.service';




@NgModule({
  declarations: [HelpCenterComponent, HelpCentersComponent, HelpCenterSecondlevelComponent, HelpCenterThirdlevelComponent, HelpCenterPreviewComponent],
  imports: [
    HelpCenterRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    SubheaderModule,
    MatMenuModule,
    NgbModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    HelpCenterService
  ]
})
export class HelpCenterModule { }
